export default __webpack_public_path__ + "3c42d762e59d34a224828c2671f9dbbe.png";